import { __assign } from "tslib";
import { initFlow, loadManager, getFlow, removeFlow, markTimePoint, getTimePoint, resumeFlow, pauseFlow, notifyNetworkStatus } from '@hose/performance-tracker';
import { addRumAction } from '../../hosting/dataflux-rum';
import { getBillEditPerfOptimizations } from '../featbit';
export var initFlowTracker = function (config) {
    return initFlow(__assign(__assign({}, config), { reporter: function (name, data) { return addRumAction(name, data); } }));
};
export var startLoadWindow = function (name, options) {
    var _a;
    var billLoadingTrack = getBillEditPerfOptimizations().billLoadingTrack;
    if (!billLoadingTrack)
        return;
    loadManager.startWindow(__assign(__assign({}, options), { name: name, reporter: function (name, data) {
            addRumAction(name, data);
            console.log("%c[LoadTracker]" + name, 'color:red', data);
        } }));
    addRumAction(name + '-start', { flowId: (_a = options === null || options === void 0 ? void 0 : options.extraOptions) === null || _a === void 0 ? void 0 : _a.flowId });
};
export { getFlow, resumeFlow, markTimePoint, getTimePoint, pauseFlow, removeFlow, notifyNetworkStatus, loadManager };
